import { makeVar } from '@apollo/client';
import { ErrorResponse } from '@apollo/client/link/error';

export const globalErrorResponseVar = makeVar<ErrorResponse | undefined>(
  undefined
);
